import React, { useState, useEffect } from "react";

import { Card, Row, Spinner, Tooltip } from "reactstrap";
import { Link, useSearchParams } from "react-router-dom";
import NavCardBody from "./NavCardBody";
import { useVsiAppContext } from "../stores/VsiApp";
import { VsiH6, VsiSmallText, VsiSpanText } from "../styled/App.styled";
import { constructQsp, returnPathWithQuery, snakeCaseToTitleCase } from "../utils/Helpers";
import themeStyles from "../utils/themeStyles";
import { DeleteAuth } from "../utils/Verbs";
import { useDebounce } from "../utils/hooks";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function NavCard({ title, path, layout, stateRollupKey, context, isBookmark, params, _id, contextIcon }) {
  const { theme, isTabletScreen, user, setUser, setAllFavoritesItems, getAccessTokenSilently, doPeriodsMatchReportContext } = useVsiAppContext();
  const [searchParams] = useSearchParams();

  const [isHoveringX, setIsHoveringX] = useState(false);
  const [isToolTipOpen, setIsToolTipOpen] = useState(false);

  const debouncedToolTipOpen = useDebounce(isHoveringX, 1000);

  useEffect(() => {
    if (isHoveringX && debouncedToolTipOpen) {
      setIsToolTipOpen(true);
    } else if (!isHoveringX) {
      setIsToolTipOpen(false);
    }
  }, [debouncedToolTipOpen, isHoveringX]);

  const linkRoute = () => {
    if (isBookmark) {
      let qsp = "";
      params?.forEach?.(({ param, value }) => qsp = constructQsp(qsp, param, value));
      return `${path}${qsp}`;
    }
    return returnPathWithQuery(path, context, searchParams);
  };

  const onDeleteClick = async e => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const token = await getAccessTokenSilently();
      const deleteFav = await DeleteAuth(`/api/v6/admin/favorite/${user._id}/${_id}`, token);
      if (deleteFav) {

        setUser(user => {
          return {
            ...user,
            favorites: user.favorites.filter(route => route._id !== _id)
          };
        });
        setAllFavoritesItems(allFavs => allFavs.filter(route => route._id !== _id));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const uriRoute = linkRoute();
  return (
    <Link to={uriRoute} style={{ textDecoration: "none", color: "inherit" }}>
      <Card className={`my-3 p-2 nav-card nav-card-${theme}`}>
        <div className={"d-flex flex-row justify-content-between align-items-center"}>
          <div className={"d-flex flex-row justify-content-start align-items-center"}>
            <i className={`fa-regular ${contextIcon} pe-2`}
               style={{ color: themeStyles[theme].reportBtnIconColor }} />
            <VsiH6 className={"fw-bold"}>
              {title}
            </VsiH6>
            <VsiSmallText className="fst-italic 50 ms-2">
              Click to see full report
            </VsiSmallText>
          </div>
          {isBookmark ? <div className={"d-flex flex-row justify-content-end report-util-btn"}>
            <i className={`fa-${isHoveringX ? "regular" : "solid"} fa-bookmark p-1 report-util-icon`}
               id={`bookmark-x-${_id}`}
               style={{ color: themeStyles[theme].reportBtnIconColor }}
               onMouseEnter={() => setIsHoveringX(true)}
               onMouseLeave={() => setIsHoveringX(false)}
               onClick={onDeleteClick} />
            <Tooltip
              isOpen={isToolTipOpen}
              target={`bookmark-x-${_id}`}
              // toggle={toggle}
            >
              Remove bookmarked report
            </Tooltip>
          </div> : null}
        </div>
        {(isBookmark && params) ? (
          params.map(({ param, value }, index) => (
            <VsiSpanText key={`descriptor-bookmark-${param}-${index} pb-0 mb-0`}>
              <VsiSmallText className={"pe-2"}>{snakeCaseToTitleCase(param)}:</VsiSmallText>
              <VsiSmallText className={"pe-2"}>{value}</VsiSmallText>
            </VsiSpanText>
          ))
        ) : null}
        <div className={"h-100"}>
          <Row className={"h-100 align-items-center"}>
            {layout.map((config = {}, index) => {
              if (index !== 0 && isTabletScreen) return null;
              return (
                <NavCardBody
                  {...config}
                  params={params}
                  isBookmark={isBookmark}
                  stateRollupKey={stateRollupKey}
                  key={`nav-card-body-${config.title
                    .toLowerCase()
                    .split(" ")
                    .join("-")}-${index}`}
                />
              );
            })}
          </Row>
        </div>
        <VsiSmallText className={"fst-italic"}>{context}</VsiSmallText>
      </Card>
    </Link>
  );
}

export default withErrorBoundary(NavCard, GeneralErrorBoundary);
